export default __webpack_public_path__ + "static/media/acuadori_home.7fdea3bd.png";